import classNames from "classnames";
import styles from "./fix-icon-indicator.module.scss";
import cart from "@/assets/shopping-cart.svg";
import { Icon } from "@/elements-react/fix-icon";
import React from "preact/compat";

export interface FixIconIndicatorProps {
  count?: number;
  slot?: string;
  className?: string;
}

export const FixIconIndicator: React.FC<FixIconIndicatorProps> = ({ count = 0, slot, className }) => {
  const indicatorVisible = typeof count === "number";
  const indicatorSize = React.useMemo(() => {
    const numbers = (count ?? 0).toString().split("").length;
    switch (numbers) {
      case 0:
      case 1:
        return styles.size1;
      case 2:
        return styles.size2;
      case 3:
      default:
        return styles.size3;
    }
  }, [count]);

  return (
    <div className={classNames(styles.root, styles.container)} slot={slot}>
      <Icon className={styles.icon} src={cart} />
      {indicatorVisible && <div className={classNames(styles.indicator, indicatorSize, className)}>{count}</div>}
    </div>
  );
};

export default FixIconIndicator;
